import {CtModelRouteData} from "@ctsolution/ct-framework";

export const LeadRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("lead");
